var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import '@cb/apricot/CBIllustration';
import cn from 'classnames';
export const illustrationSize = ['64', '72', '96'];
export const Illustration = (_a) => {
    var { illustrationId, name, size, monotone = true, duotone = false, circular = false, shadow = false, customCircular = false, className, decorative = false, k12 = false, higherEd = false } = _a, props = __rest(_a, ["illustrationId", "name", "size", "monotone", "duotone", "circular", "shadow", "customCircular", "className", "decorative", "k12", "higherEd"]);
    return (React.createElement("i", Object.assign({ id: illustrationId, className: cn(className, 'cb-ilus', monotone && 'cb-ilus-monotone', !monotone && duotone && 'cb-ilus-duotone', circular && 'cb-ilus-circular', shadow && 'cb-ilus-shadow', customCircular && 'cb-ilus-custom-circular', !monotone && k12 && 'cb-ilus-k-12', !monotone && higherEd && 'cb-ilus-higher-ed', `cb-ilus-${name}`, size && `cb-ilus-${size}`), "aria-hidden": decorative, "data-cbtrack-comp": "apricot-react:ilus" }, props)));
};
//# sourceMappingURL=Illustration.js.map